export default "__VITE_ASSET__eq7mdyzP__"